module.exports = __webpack_public_path__ + "static/media/nike-eor-winner-2.6c9aa0dd.jpg";